import React from "react";
import { NavLink } from "react-router-dom";
import { VscHome } from "react-icons/vsc";
import { BsBookmarks, BsFillSunFill, BsMoonStars } from "react-icons/bs";
import { RiBookletLine } from "react-icons/ri";
import { FiLogOut, FiGrid } from "react-icons/fi";
import { auth} from "../configs/firebaseconfig"
import {signOut} from 'firebase/auth' 
export default function NavBar({user , setShowLogin , setUser , dark,setDark, showRecpie, setOpenForm, setShowNav}) {
  const logout = async() => {
    await signOut(auth)
    setUser(null)

  }
  async function getRandomId(){
    const api= await fetch(`https://api.spoonacular.com/recipes/random?apiKey=${process.env.REACT_APP_SPOONACULAER_API}&number=1`)
    const res = await api.json()
    const el = res.recipes[0]
    showRecpie(el.id)
  }
  const appTheme = () => {
    setDark(!dark);
    localStorage.setItem("recipeTheme", !dark);
  };
  return (
    <>
      <div className={`nav-bar space-b`}>
        <div className="nav-links">
          <NavLink className="logo center" to={"/"} onClick={()=>setShowNav(false)}>
           
           
            <h4>RobotChef</h4>
          </NavLink>
          {user && 
          <div className="nav-link center add-btn" onClick={()=>{setOpenForm({open:true, item:null}) ; setShowNav(false)}}>
          
            <h4>Add New Recip</h4>
          </div>}
          <NavLink className="nav-link f-start" to={"/"} onClick={()=>setShowNav(false)}>
            <VscHome />
            <h4>home</h4>
          </NavLink>
          <NavLink className="nav-link f-start" id="explore" to={"/explore/new"} onClick={()=>setShowNav(false)}>
            <FiGrid />
            <h4>explore</h4>
          </NavLink>
          {user && 
          <>
          <NavLink className="nav-link f-start" to={"/saved"} onClick={()=>setShowNav(false)}>
            <BsBookmarks />
            <h4>saved</h4>
          </NavLink>
          <NavLink className="nav-link f-start" to={"/myrecbie"} onClick={()=>setShowNav(false)}>
            <RiBookletLine />
            <h4>my racipes</h4>
          </NavLink></>}
        </div>
        {!user && 
        <div className="login-box"> 
        <div className="s-img">
        <img src="/salad.png" alt="" />
        </div>
          <p>Sing Up and save you faviorate recpies and blogin your own racepies</p>
          <div className="btn" onClick={()=>{setShowLogin(true); setShowNav(false)}}>GO</div>
        </div>}
        <div className="nav-footer">
          <div className="s-btn center" onClick={()=>{getRandomId(); setShowNav(false)}}>Suprise me</div>
          <div className="nav-link f-start" onClick={()=>{appTheme(); setShowNav(false)}}>
          <div className="toggle center">
            <BsMoonStars />
            <BsFillSunFill />
            </div>
            <h4>{dark ? "Dark": "Light"}</h4>
          </div>
           
          {user && 
          <div className="loge-out nav-link f-start " onClick={()=>{logout(); setShowNav(false)}}>
            <FiLogOut />
            <h4>logout</h4>
          </div>}
          
        </div>
      </div>
    </>
  );
}

